import TextProperties from "./TextProperties"
import Text from "./Text"
import Customize from "./Backgrounds"
import FontSelector from "./FontSelector"
import Pixabay from "./Pixabay"
import Templates from "./Templates"
import Uploads from "./Uploads"
import Images from "./Images"
import Videos from "./Videos"
import Layers from "./Layers"
import Elements from "./Elements"
import Graphics from "./Graphics"
import TextFill from "./TextFill"
import PathFill from "./PathFill"
import CanvasFill from "./CanvasFill"
import TextEffects from "./TextEffects"
import Backgrounds from "./Backgrounds"
import Shapes from "./Shapes"
export default {
  StaticText: TextProperties,
  Text: Text,
  Backgrounds: Backgrounds,
  FontSelector: FontSelector,
  Pixabay: Pixabay,
  Templates: Templates,
  Uploads: Uploads,
  Images: Images,
  Videos: Videos,
  Elements: Elements,
  Graphics: Graphics,
  Layers: Layers,
  TextFill: TextFill,
  PathFill: PathFill,
  CanvasFill: CanvasFill,
  TextEffects: TextEffects,
  Shapes: Shapes,
}

